import { motion } from "framer-motion";
import { Video } from "lucide-react";

const steps = [
  {
    n: "1",
    title: "Park It",
    body: "Sit like you normally would. No gymnastics, no prep. Just you and the throne.",
  },
  {
    n: "2",
    title: "One Foot Up",
    body: "Plant a single foot on the Master Blaster. Left or right — dealer's choice. The other foot stays grounded.",
  },
  {
    n: "3",
    title: "Release & Flow",
    body: "The asymmetric lift relaxes your sphincter muscles and straightens the exit ramp. Gravity does the paperwork.",
  },
];

export const HowItWorks = () => (
  <section id="how-it-works" data-testid="how-it-works-section" className="relative py-24 sm:py-32 bg-midnight/40 border-y border-steel/40">
    <div className="max-w-7xl mx-auto px-4 sm:px-8">
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.7 }}
        className="mb-14"
      >
        <p className="font-jbmono text-xs uppercase tracking-[0.25em] text-ice mb-4">How It Works</p>
        <h2 className="font-display font-black uppercase text-3xl sm:text-5xl leading-none tracking-tight max-w-3xl">
          Sit. Lift one foot. <span className="text-crimson">Blast off.</span>
        </h2>
      </motion.div>

      <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-stretch">
        <motion.div
          initial={{ opacity: 0, x: -32 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.7 }}
          data-testid="video-placeholder-slot"
          className="lg:col-span-7 relative border-2 border-dashed border-steel rounded-lg bg-white flex flex-col items-center justify-center text-center gap-5 p-10 min-h-[320px] sm:min-h-[440px]"
        >
          <Video className="w-12 h-12 text-ice" />
          <p className="font-display font-black uppercase text-4xl sm:text-5xl tracking-tight text-cream/25">Insert Video Here</p>
          <p className="font-jbmono text-xs uppercase tracking-[0.25em] text-cream/50 max-w-sm leading-relaxed">
            Your Master Blaster how-to footage drops in here (.mp4)
          </p>
        </motion.div>

        <div className="lg:col-span-5 flex flex-col gap-6">
          {steps.map((s, i) => (
            <motion.div
              key={s.n}
              initial={{ opacity: 0, x: 32 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: i * 0.12 }}
              data-testid={`how-it-works-step-${s.n}`}
              className="flex gap-5 border border-steel/60 bg-midnight rounded-lg p-6"
            >
              <span className="shrink-0 w-10 h-10 rounded-sm flex items-center justify-center font-display font-black text-xl bg-crimson text-white">
                {s.n}
              </span>
              <div>
                <h3 className="font-display font-bold uppercase text-lg tracking-tight">{s.title}</h3>
                <p className="text-sm leading-relaxed text-cream/60 mt-1">{s.body}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  </section>
);
